var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirefox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100.463%",
    x2: "50%",
    y2: "68.75%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD2D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.802 10.48C2.532 9.681-.36 6.771 1.116 0c3.956.444 7.958 2.291 9.405 6.633 1.447 4.342-6.719 3.846-6.719 3.846z",
    fill: "#E46301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.234 2.606S7.59 4.472 8.211 7.582C6.967 8.826 5.723 9.448 5.723 9.448S3.234 8.204 3.234 2.606z",
    fill: "#CDD2D6"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    cx: 13,
    cy: 25.869,
    r: 2.737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.456 5.343H13v19.158c-5.943-.372-9.255-3.833-13-9.58l4.79-5.473c2.066-2.63 3.32-4.105 6.666-4.105z",
    fill: "#EC8801"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.922c2.736 4.197 4.606 7.165 8.467 8.61.68-.8 2.508-3.228 2.48-6.557-.03-3.66-4.105-6.843-7.111-6.51-.184.2-3.836 4.457-3.836 4.457z",
    fill: "#E46301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.35 18.355s3.022 6.728 9.865 6.158c1.14-1.71.048-2.749.048-2.749-.756-2.356-4.782-6.26-9.913-3.41z",
    fill: "#CDD2D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.213 10.48c1.273-.798 4.172-3.708 2.692-10.48-3.965.444-7.976 2.291-9.425 6.633-1.45 4.342 6.733 3.846 6.733 3.846z",
    fill: "#E46301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.766 2.606s-4.355 1.866-4.977 4.976c1.244 1.244 2.488 1.866 2.488 1.866s2.489-1.244 2.489-6.842z",
    fill: "#CDD2D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.544 5.343H13v19.158c5.943-.372 9.255-3.833 13-9.58l-4.79-5.473c-2.066-2.63-3.32-4.105-6.666-4.105z",
    fill: "#EC8801"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 14.922c-2.736 4.197-4.606 7.165-8.467 8.61-.68-.8-2.508-3.228-2.48-6.557.03-3.66 4.105-6.843 7.111-6.51.184.2 3.836 4.457 3.836 4.457z",
    fill: "#E46301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.65 18.355s-3.022 6.728-9.865 6.158c-1.14-1.71-.048-2.749-.048-2.749.756-2.356 4.782-6.26 9.913-3.41z",
    fill: "#CDD2D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.71 26.554h-3.42a2.395 2.395 0 1 1 0-4.79h3.42a2.395 2.395 0 1 1 0 4.79z",
    fill: "#CDD2D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.667 16.975c-1.327 0-1.825-2.053-1.825-2.053h1.825c.503 0 .912.46.912 1.026 0 .567-.409 1.027-.912 1.027zM16.421 15.948c0-.566.409-1.026.912-1.026h1.825s-.498 2.053-1.825 2.053c-.503 0-.912-.46-.912-1.027zM10.263 21.764c0 2.117 1.881 2.737 2.737 2.737.856 0 2.737-.62 2.737-2.737h-5.474z",
    fill: "#5C2415"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/firefox.2344a6fe.svg";
export { ForwardRef as ReactComponent };